import { FrameName } from "../config";
import AbstractSalvageableFightableEnemyTileEntity from "./AbstractSalvageableFightableEnemyTileEntity";

class WarriorsEnemySalvageableTileEntity extends AbstractSalvageableFightableEnemyTileEntity {
	public static readonly frameName = FrameName.WARRIORS_ENEMY;
}

export default WarriorsEnemySalvageableTileEntity;
